import styled from 'styled-components';
import {mediaMaxTablet, mediaMinTablet} from '../../constants/customMedia';
import {fontSize18, fwSemiBold} from '../../constants/typography';

export const Grid = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;

  @media ${mediaMaxTablet} {
    & > div {
      display: flex;
    }
  }

  @media ${mediaMinTablet} {
    display: flex;
    flex-wrap: wrap;
    & > * {
      display: block;
      width: calc((100% - 20px) / 3);
    }
  }
`;

export const Title = styled(`h3`)`
  ${fontSize18}
  ${fwSemiBold}

  @media ${mediaMinTablet} {
    margin-bottom: 20px;
  }
`;
